/* Claude 3.84 — poster interstitials.
   4.08 — AUTO-PAGINATION, THE PROGRESS PILL AND THE SKELETONS HAVE MOVED OUT
   of this file into assets/claude-autoload.js.

   Why: this file is loaded by snippets/claude-posters.liquid, which is rendered
   from a custom-liquid section in exactly two templates
   (collection.black-friday-sale.json and collection.cowhide-rugs.json). The
   auto-scroll layer was written here in 3.84 only because that is where the
   work was happening — it has nothing to do with posters, and welding it to the
   poster pool meant the other 29 collections got a View-more button and no
   auto-load at all. claude-autoload.js is loaded by the grid section itself, so
   it now runs everywhere; the progress pill moved with it (its markup is still
   emitted by snippets/claude-posters.liquid, and the pill code is a no-op where
   that markup is absent). The 3.84 skeleton placeholders were dropped in the
   same pass in favour of a spinner; the .cpo-sk* CSS is still in
   assets/claude-posters.css but nothing creates that markup any more.

   WHAT IS LEFT HERE IS POSTERS ONLY. They are inserted after every Nth PRODUCT
   card, re-scanned after each append, so the rhythm holds no matter how many
   products a page returns (the Black Friday template loads 70 at a time).
   Idempotent: it counts product cards and inserts only where a poster is not
   already present.

   Poster <li>s carry .cpo-item and NOT .grid__item, because the existing
   View-more loader counts `#product-grid > .grid__item` to work out how many
   products are shown. Counting posters as products would corrupt its
   "Showing X of Y" and its remaining-items maths — and now also the sentinel
   and the end-of-list arithmetic in claude-autoload.js.

   Slot follows scroll depth, as agreed: the first poster a shopper meets
   handles objections (early), the next two are proof (mid), everything
   deeper is discovery and cross-sell (late). Within a slot the pick is
   day-seeded so the page changes daily but is stable during a visit, and
   no poster repeats on one page.
*/
(function () {
  var root = document.getElementById('claude-posters-data');
  if (!root) return;

  var POOL = [];
  try { POOL = JSON.parse(root.textContent) || []; } catch (e) { POOL = []; }

  // Live catalogue numbers resolved by Liquid at render, substituted into
  // poster copy here. Volatile figures are never baked into the stored text —
  // a one-of-a-kind catalogue's stock counts would be wrong within days.
  var COUNTS = {};
  try { COUNTS = JSON.parse(root.getAttribute('data-counts')) || {}; } catch (e) { COUNTS = {}; }
  function fillTokens(s) {
    if (!s) return s;
    return s.replace(/\[\[count:([a-z0-9-]+)\]\]/gi, function (m, h) {
      return (COUNTS[h] != null) ? COUNTS[h] : '';
    });
  }
  POOL.forEach(function (p) {
    p.display = fillTokens(p.display);
    p.display_short = fillTokens(p.display_short);
    p.sub = fillTokens(p.sub);
  });

  var grid = document.getElementById('product-grid');
  if (!grid) return;

  var EVERY = parseInt(root.getAttribute('data-every'), 10) || 12;
  var SEED = parseInt(root.getAttribute('data-seed'), 10) || 1;

  /* ---------------- posters ---------------- */

  var TP_LOGO =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">' +
    '<path d="M12 1.7l3.19 6.46 7.13 1.04-5.16 5.03 1.22 7.1L12 17.98l-6.38 3.35 1.22-7.1L1.68 9.2l7.13-1.04z"/></svg>';

  var slotsByDepth = ['early', 'mid', 'mid', 'late'];
  function slotFor(i) { return i < slotsByDepth.length ? slotsByDepth[i] : 'late'; }

  var used = {};
  function pick(slot, i) {
    var eligible = POOL.filter(function (p) { return p.slot === slot && !used[p.id]; });
    if (!eligible.length) {
      eligible = POOL.filter(function (p) { return !used[p.id]; });
    }
    if (!eligible.length) return null;
    var p = eligible[(SEED + i * 7) % eligible.length];
    used[p.id] = true;
    return p;
  }

  /* 3.92: the five legacy metaobject colour values map one-to-one onto five of
     the six chosen grounds, so the pool needs no data migration and any colour
     an editor has set by hand is still honoured. Petrol is the only new name.
     An unknown value falls back to cream rather than rendering unstyled. */
  var GROUND = {
    stone: 'taupe', dark: 'charcoal', line: 'cream', ox: 'ox', olive: 'olive',
    taupe: 'taupe', charcoal: 'charcoal', cream: 'cream', petrol: 'petrol'
  };

  function posterEl(p) {
    /* 3.90: one shape only. Old metaobjects still carry half/band values;
       normalise here so the pool needs no data migration for layout. */
    p.shape = 'sq';

    /* 3.92: STYLE COMES FROM THE DATA, NOT FROM A GUESS. Every non-review entry
       in the pool has kind=statement AND an eyebrow, so no rule inferred from
       the existing fields could separate a Statement from a Label. The
       claude_poster metaobject now carries an explicit `style` field. The
       fallback below only covers entries created before that field existed. */
    var style = p.style || (p.kind === 'review' ? 'quote' : 'statement');
    if (style !== 'quote' && style !== 'label') style = 'statement';

    var ground = GROUND[p.colour] || 'cream';

    var li = document.createElement('li');
    li.className = 'cpo-item cpo-item--sq';
    li.setAttribute('data-cpo', p.id);

    var box = document.createElement('div');
    box.className = 'cpo cpo--sq cpo--' + ground + ' cpo--st-' + style;

    var text = p.display_short || p.display;

    /* Long-copy guard. display_short runs 17-33 characters across the pool;
       past 30 the display drops one step so it cannot overflow a narrow card.
       Measure the STRIPPED length - the copy carries <br> and entities. */
    var plain = String(text).replace(/<[^>]+>/g, '').replace(/&[a-z]+;/gi, 'x');
    if (plain.length > 30) box.classList.add('cpo--long');

    var html = '';
    if (style === 'quote') {
      html += '<div class="cpo__mark">&ldquo;</div>';
      html += '<div class="cpo__dp cpo__dp--quote">' + text + '</div>';
      if (p.sub) html += '<div class="cpo__att">' + p.sub + '</div>';
      // Trustpilot name AND logo are required beside any quoted review.
      if (p.eyebrow) html += '<div class="cpo__tp">' + TP_LOGO + p.eyebrow + '</div>';
    } else if (style === 'label') {
      html += '<div class="cpo__inner">';
      if (p.eyebrow) html += '<div class="cpo__eb">' + p.eyebrow + '</div>';
      html += '<div class="cpo__rule"></div>';
      html += '<div class="cpo__dp">' + text + '</div>';
      if (p.sub) html += '<div class="cpo__sb">' + p.sub + '</div>';
      html += '</div>';
    } else {
      /* Statement carries NO eyebrow by design - the sentence is the whole
         poster. Entries whose eyebrow says something a shopper needs are set
         to style=label in the metaobject instead. */
      html += '<div class="cpo__dp">' + text + '</div>';
      if (p.sub) html += '<div class="cpo__sb">' + p.sub + '</div>';
    }
    box.innerHTML = html;

    /* 3.92: NO VISIBLE LINK ON ANY POSTER ("avoid those with links
       altogether"). A review still has to link to its own review under
       Trustpilot's guidelines, so the WHOLE CARD becomes the anchor - nothing
       to see, compliance intact. Note this links to the individual review
       (review_url), never the profile page. */
    if (style === 'quote' && p.review_url) {
      var a = document.createElement('a');
      a.className = 'cpo__link';
      a.href = p.review_url;
      a.setAttribute('rel', 'noopener');
      a.setAttribute('aria-label', 'Read this review on Trustpilot');
      a.innerHTML = box.innerHTML;
      box.innerHTML = '';
      box.appendChild(a);
    }

    li.appendChild(box);
    return li;
  }

  function placePosters() {
    if (!POOL.length) return;
    var kids = Array.prototype.slice.call(grid.children);
    var productCount = 0;
    var posterIndex = 0;

    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (el.classList.contains('cpo-item')) { posterIndex++; continue; }
      /* Anything that is not a product card is skipped here — which covers the
         4.08 spinner and end-of-list marker if they ever end up inside the
         grid, and covered the 3.84 skeletons before they were removed. */
      if (!el.classList.contains('grid__item')) continue;

      productCount++;
      if (productCount % EVERY !== 0) continue;

      var next = el.nextElementSibling;
      if (next && next.classList.contains('cpo-item')) continue; // already placed
      var p = pick(slotFor(posterIndex), posterIndex);
      if (!p) return;
      el.parentNode.insertBefore(posterEl(p), next);
      posterIndex++;
    }
  }

  // Re-place posters whenever the grid changes. The auto-load layer keeps its
  // own observer in claude-autoload.js; the two are independent on purpose, so
  // either file can be removed without breaking the other.
  var mo = new MutationObserver(function () {
    clearTimeout(mo._t);
    mo._t = setTimeout(placePosters, 60);
  });
  mo.observe(grid, { childList: true });

  placePosters();
})();
